import { Injectable } from '@angular/core';
import { State } from '../reducers';
import { Store, select } from '@ngrx/store';
import { selectFilters } from '../selectors/companies.selector';
import { SetFilters } from '../actions';
import { CompanyFilters } from '../../models/company.model';

@Injectable()
export class CompaniesFacade {
  filters$ = this.store.pipe(select(selectFilters));

  constructor(private store: Store<State>) { }

  SetFilters(payload: CompanyFilters) {
    for (let key in payload) {
      if (!payload[key] && payload[key] !== 0) {
        delete payload[key];
      }
    }
    this.store.dispatch(new SetFilters(payload));
  }
}
